import React, { useState } from 'react';
import { CaretDown } from 'phosphor-react';
import './SInputField.css';
import countriesData from '../countries.json';

interface SCountryDialCodeProps {
  flag?: string;
  dialCode?: string;
  onClick?: () => void; // optional external hook when dropdown is opened
  onChange?: (dialCode: string, flag: string) => void; // callback when country is selected
}

type CountryOption = {
  code: string;
  flag: string;
  dialCode: string;
};
const COUNTRIES: CountryOption[] = countriesData as CountryOption[];

export const SCountryDialCode: React.FC<SCountryDialCodeProps> = ({
  flag,
  dialCode,
  onClick,
  onChange,
}) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<CountryOption>(
    () =>
      COUNTRIES.find((c) => c.dialCode === dialCode) || COUNTRIES[0]
  );

  const handleToggle = () => {
    setOpen((prev) => !prev);
    if (!open && onClick) onClick();
  };

  const handleSelect = (option: CountryOption) => {
    setSelected(option);
    setOpen(false);
    if (onChange) {
      onChange(option.dialCode, option.flag);
    }
  };

  const displayFlag = flag ?? selected.flag;
  const displayDialCode = dialCode ?? selected.dialCode;

  return (
    <div className="s-country-dial-container">
      <button
        type="button"
        className="s-country-dial-root"
        onClick={handleToggle}
      >
        <span className="s-input-country-flag" aria-hidden="true">
          {displayFlag}
        </span>
        <span className="s-input-country-dial">{displayDialCode}</span>
        <span className="s-input-country-chevron">
          <CaretDown size={20} />
        </span>
      </button>
      {open && (
        <div className="s-country-dial-menu">
          {COUNTRIES.map((option) => (
            <button
              key={option.code}
              type="button"
              className="s-country-dial-menu-item"
              onClick={() => handleSelect(option)}
            >
              <span className="s-input-country-flag" aria-hidden="true">
                {option.flag}
              </span>
              <span className="s-input-country-dial">{option.dialCode}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SCountryDialCode;
